'use strict';

var FaresOptimizerDateChartDirective = function FaresOptimizerDateChartDirective($timeout, FaresOptimizerDateChart) {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FaresOptimizerDateChartController',
    template: require('../templates/fares-optimizer-date-chart.html'),
    scope: {
      chartData: '=',
      screenState: '='
    },
    link: function link($scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new FaresOptimizerDateChart(chartElement);
      $scope.renderChartDataPresent = function (data) {
        chart.render(data);
      };
    }
  };
};
FaresOptimizerDateChartDirective.$inject = ['$timeout', 'FaresOptimizerDateChart'];
module.exports = FaresOptimizerDateChartDirective;